module.exports = "<div data-component=\"virtual-keyboard\">\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/virtual-keyboard/virtual-keyboard.component.html
// module id = ../../../../../src/app/shared/virtual-keyboard/virtual-keyboard.component.html
// module chunks = main